<template>
    <div id="group_chat_manage" v-if="show">
        <div
            v-if="currDetailStatus.desc"
            class="status_desc base_font_color_909399 base_font_size_14 margin_bottom_15"
        >
            <a-alert :message="currDetailStatus.desc" type="info" />
        </div>
        <a-button type="primary" class="margin_bottom_15" @click="chatModal('add')">
            添加群二维码
        </a-button>
        <a-table
            rowKey="id"
            :columns="currDetailStatus.columns"
            :data-source="currDetailStatus.list"
            :pagination="currDetailStatus.page"
            @change="changePagination"
        >
            <template slot="qrcode" slot-scope="text">
                <a-tooltip placement="right">
                    <template slot="title">
                        <img :src="text" width="100%" />
                    </template>
                    <a-avatar :src="text" size="small" shape="square" />
                </a-tooltip>
            </template>
            <template slot="action" slot-scope="text, record">
                <a-button-group style="margin-left: -7px;" class="cross_center">
                    <a-button type="link" size="small" @click="chatModal('edit', record)"
                        >编辑</a-button
                    >
                    <a-divider type="vertical" />
                    <a-button type="link" size="small" @click="deleteEnterCrode(record)"
                        >删除</a-button
                    >
                </a-button-group>
            </template>
        </a-table>
        <!-- 弹窗编辑群聊 -->
        <a-modal
            wrapClassName="edit_group"
            :visible="currDetailStatus.visible"
            :title="currDetailStatus.title"
            @ok="toOk"
            @cancel="toCancel"
        >
            <a-form-model
                ref="formRule"
                :model="currDetailStatus.form"
                :rules="currDetailStatus.formRule"
                :label-col="{ span: 6 }"
                :wrapper-col="{ span: 18 }"
                labelAlign="right"
            >
                <a-form-model-item label="客户群" prop="chatId">
                    <template
                        v-if="
                            currDetailStatus.form &&
                                currDetailStatus.form.chatId &&
                                currDetailStatus.form.name
                        "
                    >
                        <span style="margin-right: 5px;">{{ currDetailStatus.form.name }}</span>
                    </template>
                    <a-button type="link" @click="toOpen" style="padding: 0;height: auto;">
                        选择客户群
                    </a-button>
                    <groupChatModal ref="groupChatModal" @change="backGroupModal"></groupChatModal>
                </a-form-model-item>
                <a-form-model-item label="群二维码" prop="qrcode">
                    <a-upload
                        accept=".jpg, .jpeg, .png"
                        :action="`${baseUrl}/material/upload_cover`"
                        :headers="headers"
                        :showUploadList="false"
                        :before-upload="beforeUpload"
                        @change="uploadCoverChange"
                    >
                        <div class="upload_list_item" v-if="currDetailStatus.form.qrcode">
                            <div class="upload_list_item_info">
                                <a-spin v-if="currDetailStatus.loading">
                                    <a-icon slot="indicator" type="loading" spin />
                                </a-spin>
                                <img
                                    :src="currDetailStatus.form.qrcode"
                                    width="80"
                                    height="80"
                                    v-else
                                />
                                <span class="upload_list_item_icon" style="margin-left: 5px;">
                                    <a-icon type="upload"></a-icon> 修改
                                </span>
                            </div>
                        </div>
                        <a-button :loading="currDetailStatus.loading" icon="upload" v-else>
                            上传图片
                        </a-button>
                    </a-upload>
                    <div class="base_font_color_00025 base_font_size_12" style="line-height: 1.5;">
                        支持jpg/png格式图片，且不超过2M；群二维码需和客户群对应。
                    </div>
                </a-form-model-item>
                <a-form-model-item label="群二维码有效期" prop="endTime">
                    <a-date-picker
                        format="YYYY-MM-DD HH:mm:ss"
                        v-model="currDetailStatus.form.endTime"
                        :disabled-date="disabledDate"
                        :disabled-time="disabledDateTime"
                        :showTime="true"
                        @change="getDateTime"
                        v-if="currDetailStatus.form.relId"
                        class="a1"
                    />
                    <a-date-picker
                        format="YYYY-MM-DD HH:mm:ss"
                        :disabled-date="disabledDate"
                        :disabled-time="disabledDateTime"
                        :showTime="true"
                        @change="getDateTime"
                        v-else-if="!currDetailStatus.form.relId && currDetailStatus.visible"
                        class="a2"
                    />
                    <div class="base_font_color_00025 base_font_size_12" style="line-height: 1.5;">
                        群二维码有效期为7天，请填写群二维码上的日期。
                    </div>
                </a-form-model-item>
            </a-form-model>
        </a-modal>
    </div>
</template>

<script>
import api from '@/apis';
import _ from 'lodash';
import dayjs from 'dayjs';
import groupChatModal from '@/components/group/groupChatModal';
export default {
    // 群聊管理组件
    name: 'group_chat_manage',
    props: {
        show: {
            type: Boolean,
            default: function() {
                return false;
            }
        },
        // 当前群码信息
        currQcrode: {
            type: Object,
            default: () => {}
        },
        // 组件类型 add: 新建群码组件时，传参不会清空status=1的群聊列表数据，其他都会清空一次status=1的列表请求
        type: {
            type: String,
            default: ''
        }
    },
    components: {
        groupChatModal
    },
    data() {
        return {
            baseUrl: process.env.VUE_APP_BASEURL,
            headers: {},
            currDetailStatus: {
                desc:
                    '微信群超过200人只能邀请进群，当群人数达到190人时，将自动切换成下一个群二维码。',
                // 群聊表格数据
                columns: [
                    {
                        title: '群二维码',
                        dataIndex: 'qrcode',
                        scopedSlots: { customRender: 'qrcode' }
                    },
                    {
                        title: '群名称',
                        dataIndex: 'name'
                    },
                    {
                        title: '群人数',
                        dataIndex: 'number'
                    },
                    {
                        title: '群二维码有效期截止',
                        dataIndex: 'endTime'
                    },
                    {
                        title: '操作',
                        dataIndex: 'action',
                        scopedSlots: { customRender: 'action' },
                        width: 150
                    }
                ],
                list: [],
                page: {
                    total: 0,
                    pageSize: 10
                },
                params: {
                    page: 1,
                    keywords: null
                },
                visible: false,
                form: {},
                formRule: {
                    name: [{ required: true, message: '请选择客户群', trigger: 'change' }],
                    chatId: [{ required: true, message: '请选择客户群', trigger: 'change' }],
                    qrcode: [{ required: true, message: '请上传群二维码', trigger: 'change' }],
                    endTime: [
                        { required: true, message: '请输入群二维码有效期', trigger: 'change' }
                    ]
                },
                loading: false
            }
        };
    },
    created() {},
    computed: {},
    mounted() {
        if (this.show) {
            const token = window.sessionStorage.getItem('token');
            this.headers.Authorization = `Bearer ${token}`;
            this.getEnterCrodeList(this.currQcrode);
        }
    },
    methods: {
        // 时间筛选
        dayjs,
        disabledDate(current) {
            return (
                current &&
                current <
                    dayjs()
                        .subtract(1, 'day')
                        .endOf('day')
            );
        },
        disabledDateTime() {
            return {
                disabledHours: () => [],
                disabledMinutes: () => [],
                disabledSeconds: () => []
            };
        },
        getDateTime(date, str) {
            const curr = this.currDetailStatus;
            if (str) curr.form.endTime = str;
        },
        // 获取企业微信群码列表
        async getEnterCrodeList(listData) {
            try {
                if (!listData || (listData && !listData.groupId && listData.groupId !== 0))
                    return this.$message.error(`未获取当前群码信息`);
                if (!this.currDetailStatus) return this.$message.error(`未获取当状态信息`);
                const curStatus = this.currDetailStatus;
                const params = {
                    groupId: listData.groupId
                };
                if (curStatus && curStatus.params.page >= 1) params.page = curStatus.params.page;
                if (curStatus && curStatus.params.keywords)
                    params.keywords = curStatus.params.keywords;
                // 标记当前状态 this.currQcrode.initNum > 1 带不清除命令请求列表，反之都会清空groupId = 0的数据
                if (this.type === 'add' && this.currQcrode.initNum > 1) params.clear = 'no';
                const res = await api.getEnterCrodeList(params);
                if (res.code !== 0) return this.$message.error(`获取企业微信群码列表报错`);
                curStatus.list = res.rows;
                curStatus.page = {
                    total: res.count,
                    pageSize: res.pageSize
                };
                if (this.type === 'add') {
                    this.$emit('backChatId', res.rows);
                }
            } catch (err) {
                console.log(err);
            }
        },
        // 翻页
        changePagination(pagination, filters, sorter, currentDataSource) {
            const curr = this.currDetailStatus;
            // 群聊翻页
            curr.params.page = pagination.current;
            this.getEnterCrodeList(this.currQcrode);
        },
        // 删除群聊
        async deleteEnterCrode(record) {
            const that = this;
            if (!record || (record && !record.id)) return that.$message.error(`未获取当前群聊信息`);
            const params = {
                relId: record.id
            };
            try {
                this.$confirm({
                    title: `确认删除群聊？`,
                    icon: 'info-circle',
                    async onOk() {
                        const res = await api.deleteEnterCrode(params);
                        if (res.code !== 0) return that.$message.error(`删除群聊报错`);
                        that.$message.success('删除成功');
                        that.getEnterCrodeList(that.currQcrode);
                    },
                    onCancel() {}
                });
            } catch (err) {
                console.log(err);
            }
        },
        // 添加群聊
        chatModal(type, record) {
            const curr = this.currDetailStatus;
            const currQcrode = this.currQcrode;
            if (type === 'add') {
                curr.title = '新增群二维码';
                curr.form = {
                    groupId: currQcrode.groupId,
                    name: '',
                    chatId: '',
                    qrcode: '',
                    endTime: '',
                    status: this.type === 'add' ? 1 : 2
                };
            } else if (type === 'edit') {
                curr.title = '编辑群二维码';
                curr.form = {
                    groupId: currQcrode.groupId,
                    relId: record.id,
                    name: record.name,
                    chatId: record.chatId,
                    qrcode: record.qrcode,
                    endTime: dayjs(record.endTime),
                    status: this.type === 'add' ? 1 : 2
                };
            }
            curr.visible = !curr.visible;
        },
        // 确认
        async toOk() {
            try {
                const curr = this.currDetailStatus;
                let params = {};
                if (
                    !curr.form ||
                    (curr.form &&
                        (!curr.form.name ||
                            !curr.form.chatId ||
                            !curr.form.qrcode ||
                            !curr.form.endTime ||
                            !curr.form.status))
                )
                    return this.$message.error(`请提交表单必填项数据`);
                params = {
                    groupId: curr.form.groupId,
                    name: curr.form.name,
                    chatId: curr.form.chatId,
                    qrcode: curr.form.qrcode,
                    endTime: curr.form.endTime,
                    status: curr.form.status
                };
                if (curr.form && curr.form.relId) params.relId = curr.form.relId;
                const res = await (!curr.form.relId
                    ? api.createEnterCrode(params)
                    : api.updateEnterCrode(params));
                if (res.code !== 0)
                    return this.$message.error(
                        !curr.form.relId ? `创建群聊信息报错` : `编辑群聊信息报错`
                    );
                this.$message.success(!curr.form.relId ? `添加成功` : `编辑成功`);
                curr.visible = !curr.visible;
                // 递增标记参数，方便请求列表判断，是否要清除groupId=0的记录
                this.currQcrode.initNum++;
                this.getEnterCrodeList(this.currQcrode);
            } catch (err) {
                console.log(err);
            }
        },
        // 取消 / 关闭
        toCancel() {
            const curr = this.currDetailStatus;
            curr.visible = !curr.visible;
            curr.form = {};
        },
        uploadCoverChange({ file }) {
            const curr = this.currDetailStatus;
            if (file.status === 'uploading') curr.loading = true;
            if (file.status === 'done') {
                curr.loading = false;
                const res = file.response;
                if (res.code === 0) {
                    curr.form.qrcode = res.url;
                }
            }
        },
        // 上传图片限制
        beforeUpload(file) {
            const isJPG =
                file.type === 'image/png' ||
                file.type === 'image/jpeg' ||
                file.type === 'image/jpg';
            if (!isJPG) {
                this.$message.error('您只能上传JPG/PNG图片！');
            }
            const isLt2M = file.size / 1024 / 1024 < 2;
            if (!isLt2M) {
                this.$message.error('上传的图片必须小于2MB！');
            }
            return isJPG && isLt2M;
        },
        // 打开
        toOpen() {
            this.$refs.groupChatModal.open();
        },
        backGroupModal(data) {
            const curr = this.currDetailStatus;
            if (data && data.name && data.chatId) {
                curr.form.name = data.name;
                curr.form.chatId = data.chatId;
            }
            if (data && !data.name) this.$message.error(`群名称为空，重新选择客户群`);
            if (data && !data.chatId) this.$message.error(`群id为空，重新选择客户群`);
        }
    }
};
</script>

<style scoped>
#group_chat_manage .margin_bottom_15 {
    margin-bottom: 15px;
}
#group_chat_manage .status_desc {
    line-height: 1;
}
</style>
